var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavySnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1902 25.4582C13.8654 23.9367 10 19.3821 10 14C10 7.37258 15.861 2 23.0909 2C27.9364 2 32.167 4.41319 34.4305 8H37C41.9706 8 46 12.0294 46 17C46 21.9706 41.9706 26 37 26H22.2727C21.1899 26 20.1517 25.8088 19.1902 25.4582Z",
    fill: "#D9DBE9",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1994 35.2687V35.1948L42.2634 35.2318L42.1994 35.2687Z",
    fill: "#D9DBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1994 31V39M39 33.3477L45.5265 37.1157M39 37.1159L45.5265 33.3478",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19938 41.2687V41.1948L7.26338 41.2318L7.19938 41.2687Z",
    fill: "#D9DBE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19938 37V45M4 39.3477L10.5265 43.1157M4 43.1159L10.5265 39.3478",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49021 29.5336V29.5244L9.50002 29.529L9.49021 29.5336Z",
    fill: "#D9DBE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49021 29V30M9 29.2935L10 29.7645M9 29.7645L10 29.2935",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4902 45.5336V45.5244L36.5 45.529L36.4902 45.5336Z",
    fill: "#D9DBE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4902 45V46M36 45.2935L37 45.7645M36 45.7645L37 45.2935",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 38.2006V38.2001L24.1672 38.2004L24.1668 38.2006Z",
    fill: "#D9DBE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 32V44.4004M19 34.48L29.3337 41.9202M19 41.9207L29.3337 34.4805",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavySnow);
export default __webpack_public_path__ + "static/media/heavy-snow.edc82134e7b40adb7e4c13168068eb73.svg";
export { ForwardRef as ReactComponent };